export default __webpack_public_path__ + "static/media/page_bg.b2854af5.jpg";